import Vue from 'vue'
import Router from 'vue-router'

import Main from '../views/index'

Vue.use(Router);

export default new Router({
  mode : 'history',
  routes:[
    {
      path: '/',
      component: Main
    }
  ]
})







// WEBPACK FOOTER //
// ./src/router/index.js